"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getOrgIdHeaders = void 0;
function getOrgIdHeaders(platformOrgId) {
    return { "x-ap-context": `${platformOrgId}` };
}
exports.getOrgIdHeaders = getOrgIdHeaders;
